export class CnstPMMarkCompleteParam
{
    //confirmationValues: any;
    dispatchId: any;
    insertUserId: any;
    pMPersonId: any;
    costAdjustmentAmount: number;
}
